import React from 'react';
import { graphql } from 'gatsby';

import { useFelaEnhanced } from '@ackee/fela';

import { Title, TitleTypes, DynamicContainer, ContainerType, Divider } from 'modules/ui';

import { InquirySection } from 'modules/inquiry';
import { MarkdownContent } from 'modules/mdx';

import { BlogContentContainer } from '../BlogContentContainer';
import { BlogBackLink } from '../BlogBackLink';
import { OtherPosts } from '../OtherPosts';
import type { BlogPost, GlossaryItem } from '../../types';

import * as felaRules from './GlossaryItemPage.rules';
import { MetadataContainer } from '../MetadataContainer';

export interface GlossaryItemPageProps extends GlossaryItem {
    otherPosts: BlogPost[];
}

export const GlossaryItemPage = ({ title, content, otherPosts }: GlossaryItemPageProps) => {
    const { rules } = useFelaEnhanced(felaRules);

    return (
        <>
            <article>
                <DynamicContainer as={ContainerType.HEADER} isFluid extend={{ container: rules.container }}>
                    <BlogBackLink />
                    {/** @ts-expect-error */}
                    <Title type={TitleTypes.H3} as={TitleTypes.H1}>
                        {title}
                    </Title>
                </DynamicContainer>
                <BlogContentContainer>
                    <MarkdownContent body={content?.data.childMdx.body} />
                    <MetadataContainer title={title} />
                </BlogContentContainer>
            </article>

            <OtherPosts posts={otherPosts} />

            {/** @ts-expect-error */}
            <Divider />
            <InquirySection />
        </>
    );
};

export const glossaryItemQuery = graphql`
    fragment GlossaryItem on STRAPI_GLOSSARY {
        id
        title
        content {
            data {
                childMdx {
                    body
                }
            }
        }
        seo {
            metaTitle
            metaDescription
            keywords
        }
    }
`;
